import RM1DPositioningModal from './RM_1D_positioning-modal.vue'
export default RM1DPositioningModal
